(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-cart-drawer';
  var OPEN_CLASS = 'is-open';
  var BODY_LOCK_CLASS = 'oddit-cart-drawer-open';

  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  /* ------------------------------------------------------------------ *
   * Helpers
   * ------------------------------------------------------------------ */

  function formatMoney(cents, currencyCode) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var code =
      currencyCode ||
      (cartState && cartState.currency) ||
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      'USD';
    try {
      return new Intl.NumberFormat(
        (window.Shopify && window.Shopify.locale) ||
          document.documentElement.lang ||
          undefined,
        { style: 'currency', currency: code }
      ).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2);
    }
  }

  function dispatchCartUpdated(cart) {
    try {
      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: { cart: cart } })
      );
    } catch (err) {
      /* noop */
    }
  }

  function jsonFetch(url, options) {
    var opts = options || {};
    var headers = Object.assign(
      {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      opts.headers || {}
    );

    return fetch(url, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
      credentials: 'same-origin'
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok) {
            var err = new Error(
              (data && data.description) ||
                (data && data.message) ||
                'Cart request failed'
            );
            err.status = res.status;
            err.data = data;
            throw err;
          }
          return data;
        });
    });
  }

  /* ------------------------------------------------------------------ *
   * Cart API (module-scoped so every section instance uses the same one)
   * ------------------------------------------------------------------ */

  var sections = [];
  var cartState = null;

  function registerSection(section) {
    if (sections.indexOf(section) === -1) sections.push(section);
  }

  function unregisterSection(section) {
    var i = sections.indexOf(section);
    if (i !== -1) sections.splice(i, 1);
  }

  var lastSectionApplyAt = 0;
  var SECTION_APPLY_GUARD_MS = 1500;

  // Reliable section refresh via Shopify's Section Rendering API.
  // GET /?section_id=<id> returns the section's freshly rendered HTML
  // against the current session, regardless of which endpoint mutated it.
  function fetchSectionHtml(sectionId) {
    return fetch(
      '/?section_id=' + encodeURIComponent(sectionId),
      { credentials: 'same-origin' }
    ).then(function (res) {
      if (!res.ok) throw new Error('section fetch failed: ' + res.status);
      return res.text();
    });
  }

  function refreshSectionsViaApi() {
    if (!sections.length) return Promise.resolve();
    return Promise.all(
      sections.map(function (section) {
        return fetchSectionHtml(section.id)
          .then(function (html) { applyRenderedSection(section, html); })
          .catch(function (err) {
            console.error('[oddit-cart-drawer] section refresh failed', err);
          });
      })
    ).then(function () {
      lastSectionApplyAt = Date.now();
    });
  }

  // Update header badges + upsell filtering without touching section DOM
  // (the section refresh path above is the source of truth for the drawer).
  function refreshCartMeta() {
    return jsonFetch('/cart.js', { method: 'GET' }).then(function (cart) {
      if (!cart) return cart;
      cartState = cart;
      updateHeaderBadges(cart);
      filterUpsells(cart);
      dispatchCartUpdated(cart);
      return cart;
    });
  }

  function refreshAfterMutation() {
    // The Section Rendering API output (refreshSectionsViaApi) is the single
    // source of truth for line prices: it re-renders the Liquid with
    // `money_without_trailing_zeros` in the active market/currency, so prices
    // are both quantity-aware (final_line_price) and currency-correct.
    // refreshCartMeta only updates header badges and upsell visibility.
    return Promise.all([refreshSectionsViaApi(), refreshCartMeta()]).then(
      function (results) {
        return results[1];
      }
    );
  }

  // function addToCart(variantId, quantity, properties) {
  //   var body = {
  //     id: Number(variantId),
  //     quantity: quantity != null ? Number(quantity) : 1
  //   };
  //   if (properties && Object.keys(properties).length) {
  //     body.properties = properties;
  //   }
  //   return jsonFetch('/cart/add.js', {
  //     method: 'POST',
  //     body: body
  //   }).then(refreshAfterMutation);
  // }

// KACHING EDIT START

function addToCart(variantId, quantity, properties) {
  var bundlesBlock = document.querySelector('kaching-bundles-block');

  // Only apply bundle logic if the action came from the bundle block itself,
  // NOT from cart upsells or other cart elements
  var activeEl = document.activeElement;
  var isFromCart = activeEl && !!activeEl.closest(
    '.cart, .cart-drawer, [id*="cart"], [class*="cart-drawer"], [class*="cart-items"], ajax-cart, cart-drawer'
  );

  if (bundlesBlock && !isFromCart) {
    var items = bundlesBlock.items();
    if (items && items.length) {
      var isBundleAdd = items.some(function(item) {
        return Number(item.id) === Number(variantId)
            && Number(item.quantity) === Number(quantity != null ? quantity : 1);
      });
      if (isBundleAdd) {
        return jsonFetch('/cart/add.js', {
          method: 'POST',
          body: { items: items }
        }).then(refreshAfterMutation);
      }
    }
  }

  var body = {
    id: Number(variantId),
    quantity: quantity != null ? Number(quantity) : 1
  };
  if (properties && Object.keys(properties).length) {
    body.properties = properties;
  }
  return jsonFetch('/cart/add.js', {
    method: 'POST',
    body: body
  }).then(refreshAfterMutation);
}
// KACHING EDIT END

  function addMultipleToCart(items) {
    var normalized = (items || []).map(function (item) {
      var entry = {
        id: Number(item.id),
        quantity: item.quantity != null ? Number(item.quantity) : 1
      };
      if (item.properties && Object.keys(item.properties).length) {
        entry.properties = item.properties;
      }
      if (item.selling_plan) entry.selling_plan = item.selling_plan;
      return entry;
    });
    return jsonFetch('/cart/add.js', {
      method: 'POST',
      body: { items: normalized }
    }).then(refreshAfterMutation);
  }

  function updateLineItemQuantity(lineItemKey, quantity) {
    return jsonFetch('/cart/change.js', {
      method: 'POST',
      body: { id: lineItemKey, quantity: Number(quantity) }
    }).then(refreshAfterMutation);
  }

  function removeFromCart(lineItemKey) {
    return updateLineItemQuantity(lineItemKey, 0);
  }

  function updateLineItemToSubscription(lineItemKey, sellingPlanId) {
    return jsonFetch('/cart/change.js', {
      method: 'POST',
      body: {
        id: lineItemKey,
        selling_plan: Number(sellingPlanId)
      }
    }).then(refreshAfterMutation);
  }

  function getCart() {
    return jsonFetch('/cart.js', { method: 'GET' });
  }

  function refreshCart() {
    return refreshAfterMutation();
  }

  /* ------------------------------------------------------------------ *
   * DOM rendering \u2014 delegates to Shopify's Section Rendering API,
   * which returns fully rendered section HTML with the post-mutation
   * cart state. The liquid template is the single source of truth.
   * ------------------------------------------------------------------ */

  // Selectors whose subtree depends on cart state. For each we either
  // replace innerHTML or toggle the `hidden` attribute to match the
  // server-rendered version.
  // [data-cart-items] is reconciled key-by-key via syncCartItems so the
  // product <img> element is preserved across quantity changes (avoids
  // the image re-decoding flash).
  var SYNC_INNER_HTML = [
    '[data-cart-empty]',
    '.oddit-cart-drawer__totals'
  ];

  var SYNC_HIDDEN = [
    '[data-cart-filled]',
    '[data-cart-empty]',
    '[data-cart-footer]'
  ];

  function syncText(curr, next, selector) {
    var c = curr.querySelector(selector);
    var n = next.querySelector(selector);
    if (c && n) c.textContent = n.textContent;
  }

  function syncInnerHTML(curr, next, selector) {
    var c = curr.querySelector(selector);
    var n = next.querySelector(selector);
    if (c && n) c.innerHTML = n.innerHTML;
  }

  function syncHidden(curr, next, selector) {
    var c = curr.querySelector(selector);
    var n = next.querySelector(selector);
    if (!c || !n) return;
    if (n.hasAttribute('hidden')) c.setAttribute('hidden', '');
    else c.removeAttribute('hidden');
  }

  // Reconciles the line-item list by data-line-item-key, reusing existing
  // <li data-cart-item> nodes (and crucially their <img> children) so the
  // image doesn't flash on quantity changes. Only the details subtree —
  // which holds title, caption, prices, quantity value, remove — is
  // re-rendered from the server HTML.
  function syncCartItems(curr, next) {
    var currContainer = curr.querySelector('[data-cart-items]');
    var nextContainer = next.querySelector('[data-cart-items]');
    if (!currContainer || !nextContainer) return;

    var currByKey = {};
    Array.prototype.forEach.call(
      currContainer.querySelectorAll('[data-cart-item]'),
      function (el) {
        var key = el.getAttribute('data-line-item-key');
        if (key) currByKey[key] = el;
      }
    );

    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(
      nextContainer.querySelectorAll('[data-cart-item]'),
      function (nextEl) {
        var key = nextEl.getAttribute('data-line-item-key');
        var existing = key ? currByKey[key] : null;
        if (existing) {
          var currDetails = existing.querySelector(
            '.oddit-cart-drawer__item-details'
          );
          var nextDetails = nextEl.querySelector(
            '.oddit-cart-drawer__item-details'
          );
          if (currDetails && nextDetails) {
            currDetails.innerHTML = nextDetails.innerHTML;
          }
          frag.appendChild(existing);
          delete currByKey[key];
        } else {
          frag.appendChild(nextEl.cloneNode(true));
        }
      }
    );

    currContainer.innerHTML = '';
    currContainer.appendChild(frag);
  }

  function applyRenderedSection(sectionEl, html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newSection = doc.querySelector('.oddit-cart-drawer');
    if (!newSection) return;

    // Heading count
    syncText(sectionEl, newSection, '[data-cart-drawer-count]');

    syncCartItems(sectionEl, newSection);

    // Preserves element references (listeners stay attached to the
    // items container itself; only its children are swapped).
    SYNC_INNER_HTML.forEach(function (sel) {
      syncInnerHTML(sectionEl, newSection, sel);
    });
    SYNC_HIDDEN.forEach(function (sel) {
      syncHidden(sectionEl, newSection, sel);
    });

    // Checkout button \u2014 sync label/total and disabled state without
    // replacing the button element (preserves the form submit wiring).
    var currBtn = sectionEl.querySelector('[data-cart-checkout]');
    var nextBtn = newSection.querySelector('[data-cart-checkout]');
    if (currBtn && nextBtn) {
      currBtn.innerHTML = nextBtn.innerHTML;
      currBtn.disabled =
        nextBtn.hasAttribute('disabled') || nextBtn.disabled;
    }
  }

  // Header cart badges live outside the drawer section, so Section
  // Rendering from the cart drawer won't touch them. Update them
  // directly from the cart JSON.
  function updateHeaderBadges(cart) {
    var count = cart.item_count || 0;
    var badgeEls = document.querySelectorAll('[data-cart-count]');
    badgeEls.forEach(function (el) {
      el.textContent = String(count);
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  // Bundle upsell cards for products already in the cart should be
  // hidden. This is a JS-only concern because the section is rendered
  // once per request.
  function filterUpsells(cart) {
    var productIds = (cart.items || []).map(function (item) {
      return String(item.product_id);
    });

    sections.forEach(function (section) {
      var cards = section.querySelectorAll('[data-product-id]');
      cards.forEach(function (card) {
        var pid = String(card.getAttribute('data-product-id'));
        if (productIds.indexOf(pid) !== -1) {
          card.setAttribute('hidden', '');
          card.style.display = 'none';
        } else {
          card.removeAttribute('hidden');
          card.style.display = '';
        }
      });

      // Hide the bundle wrapper (heading + scroll) and its divider when
      // every card inside is hidden.
      var bundleWrapper = section.querySelector('.oddit-cart-drawer__bundle');
      if (bundleWrapper) {
        var visibleCount = bundleWrapper.querySelectorAll(
          '.oddit-cart-drawer__bundle-card:not([hidden])'
        ).length;
        var divider = bundleWrapper.previousElementSibling;
        if (visibleCount === 0) {
          bundleWrapper.setAttribute('hidden', '');
          bundleWrapper.style.display = 'none';
          if (divider && divider.classList.contains('oddit-cart-drawer__divider')) {
            divider.setAttribute('hidden', '');
            divider.style.display = 'none';
          }
        } else {
          bundleWrapper.removeAttribute('hidden');
          bundleWrapper.style.display = '';
          if (divider && divider.classList.contains('oddit-cart-drawer__divider')) {
            divider.removeAttribute('hidden');
            divider.style.display = '';
          }
        }
      }
    });
  }

  function renderCart(cart) {
    if (!cart) return;
    cartState = cart;

    if (cart.sections && typeof cart.sections === 'object') {
      sections.forEach(function (section) {
        var html = cart.sections[section.id];
        if (html) applyRenderedSection(section, html);
      });
    }

    updateHeaderBadges(cart);
    filterUpsells(cart);
    dispatchCartUpdated(cart);
  }

  /* ------------------------------------------------------------------ *
   * Per-section initialization (UI shell)
   * ------------------------------------------------------------------ */

  function initSection(section) {
    if (!section || section.dataset.odditCartDrawerInit === 'true') return;
    section.dataset.odditCartDrawerInit = 'true';
    registerSection(section);

    // Defensive: ensure the drawer is closed on init. The Liquid renders
    // without is-open, but bfcache restore can replay DOM state from a
    // previous session where the drawer was open.
    section.classList.remove(OPEN_CLASS);
    section.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_LOCK_CLASS);

    // The Liquid renders the section with inline display:none so it doesn't
    // flash before JS boots. Wait for the section's stylesheet to be applied
    // (it loads non-blocking via media="print" → onload swap unless
    // above_the_fold is enabled) before clearing it — otherwise the section
    // briefly renders in document flow without its position:fixed / panel
    // transform, flashing on every page load.
    function clearInlineDisplayWhenReady() {
      if (section.style.display !== 'none') return;
      if (window.getComputedStyle(section).position === 'fixed') {
        section.style.display = '';
      } else {
        window.requestAnimationFrame(clearInlineDisplayWhenReady);
      }
    }
    clearInlineDisplayWhenReady();

    var overlay = section.querySelector('[data-cart-drawer-overlay]');
    var closeBtn = section.querySelector('[data-cart-drawer-close]');
    var panel = section.querySelector('.oddit-cart-drawer__panel');
    var itemsContainer = section.querySelector('[data-cart-items]');
    var checkoutBtn = section.querySelector(
      '.oddit-cart-drawer__checkout, .oddit-cart-drawer__checkout-cta, [data-cart-checkout]'
    );

    var abortController = new AbortController();
    var signal = abortController.signal;
    section.__odditAbortController = abortController;

    var lastFocused = null;

    function getFocusable() {
      if (!panel) return [];
      return Array.prototype.slice
        .call(panel.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter(function (el) {
          return (
            !el.hasAttribute('disabled') &&
            el.offsetParent !== null &&
            el.getAttribute('aria-hidden') !== 'true'
          );
        });
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function open() {
      if (section.classList.contains(OPEN_CLASS)) return;
      lastFocused = document.activeElement;
      section.classList.add(OPEN_CLASS);
      section.setAttribute('aria-hidden', 'false');
      document.body.classList.add(BODY_LOCK_CLASS);

      // Refresh cart state on open so it's in sync with server, unless an
      // add-to-cart just rendered fresh sections (avoid overwriting them
      // with a stale GET response).
      var sectionsJustApplied =
        Date.now() - lastSectionApplyAt < SECTION_APPLY_GUARD_MS;
      if (sectionsJustApplied) {
        refreshCartMeta().catch(function () {
          /* noop */
        });
      } else {
        refreshCart().catch(function () {
          /* noop */
        });
      }

      // Move focus inside the drawer
      window.requestAnimationFrame(function () {
        var focusable = getFocusable();
        var target =
          (closeBtn && !closeBtn.disabled && closeBtn) ||
          focusable[0] ||
          panel;
        if (target && typeof target.focus === 'function') target.focus();
      });
    }

    function close() {
      if (!section.classList.contains(OPEN_CLASS)) return;
      section.classList.remove(OPEN_CLASS);
      section.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(BODY_LOCK_CLASS);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try {
          lastFocused.focus();
        } catch (err) {
          /* noop */
        }
      }
    }

    function toggle() {
      if (section.classList.contains(OPEN_CLASS)) close();
      else open();
    }

    /* ---------- overlay / close / keyboard ---------- */

    if (overlay) overlay.addEventListener('click', close, { signal: signal });
    if (closeBtn)
      closeBtn.addEventListener('click', close, { signal: signal });

    document.addEventListener(
      'keydown',
      function (e) {
        if (!section.classList.contains(OPEN_CLASS)) return;
        if (e.key === 'Escape') {
          close();
        } else if (e.key === 'Tab') {
          trapFocus(e);
        }
      },
      { signal: signal }
    );

    if (panel) {
      panel.addEventListener(
        'click',
        function (e) {
          e.stopPropagation();
        },
        { signal: signal }
      );
    }

    /* ---------- checkout button ---------- */

    if (checkoutBtn) {
      checkoutBtn.addEventListener(
        'click',
        function (e) {
          // Let the <form action="/cart"> submit happen naturally if inside
          // a form (name="checkout"); otherwise navigate manually.
          var form = checkoutBtn.closest('form[action*="/cart"]');
          if (form) return; // native submit
          e.preventDefault();
          window.location.href = '/checkout';
        },
        { signal: signal }
      );
    }

    /* ---------- event delegation: quantity + remove (line items) ---------- */

    if (itemsContainer) {
      itemsContainer.addEventListener(
        'click',
        function (e) {
          var decBtn = e.target.closest(
            '[data-quantity-decrease], [data-quantity-action="decrease"]'
          );
          var incBtn = e.target.closest(
            '[data-quantity-increase], [data-quantity-action="increase"]'
          );
          var removeBtn = e.target.closest(
            '[data-cart-remove], [data-remove-line]'
          );

          var actionBtn = decBtn || incBtn || removeBtn;
          if (!actionBtn) return;

          var lineItem = actionBtn.closest('[data-cart-item]');
          if (lineItem && lineItem.classList.contains('is-busy')) return;

          var lineKey =
            actionBtn.getAttribute('data-line-key') ||
            (lineItem && lineItem.getAttribute('data-line-item-key')) ||
            (lineItem && lineItem.getAttribute('data-line-key'));
          if (!lineKey) return;

          e.preventDefault();
          if (lineItem) lineItem.classList.add('is-busy');

          var promise;
          if (removeBtn) {
            promise = removeFromCart(lineKey);
          } else {
            var valueEl = lineItem
              ? lineItem.querySelector('[data-quantity-value]')
              : null;
            var current = valueEl
              ? parseInt(valueEl.textContent, 10) || 0
              : 0;
            var next = decBtn ? current - 1 : current + 1;
            if (next < 0) next = 0;
            promise = updateLineItemQuantity(lineKey, next);
          }

          promise
            .catch(function (err) {
              console.error('[oddit-cart-drawer]', err);
            })
            .finally(function () {
              if (lineItem) lineItem.classList.remove('is-busy');
            });
        },
        { signal: signal }
      );
    }

    /* ---------- upsell / cross-sell / subscription switch ---------- */

    section.addEventListener(
      'click',
      function (e) {
        // Accelerated checkout container — do not interfere
        if (e.target.closest('[data-cart-additional-checkout]')) return;

        var switchBtn = e.target.closest(
          '.oddit-cart-drawer__switch-cta[data-selling-plan-id], [data-switch-subscription][data-selling-plan-id]'
        );
        if (switchBtn) {
          e.preventDefault();
          var planId = switchBtn.getAttribute('data-selling-plan-id');
          var explicitKey = switchBtn.getAttribute('data-line-key');
          var keys = [];
          if (explicitKey) {
            keys = [explicitKey];
          } else if (cartState && cartState.items) {
            keys = cartState.items
              .filter(function (item) {
                return !item.selling_plan_allocation;
              })
              .map(function (item) {
                return item.key;
              });
          }
          if (!keys.length || !planId) return;

          switchBtn.disabled = true;
          var chain = Promise.resolve();
          keys.forEach(function (k) {
            chain = chain.then(function () {
              return updateLineItemToSubscription(k, planId);
            });
          });
          chain
            .catch(function (err) {
              console.error('[oddit-cart-drawer]', err);
            })
            .finally(function () {
              switchBtn.disabled = false;
            });
          return;
        }

        // Add-to-cart buttons inside the drawer are handled by the global
        // [data-add-to-cart][data-variant-id] delegation below.
      },
      { signal: signal }
    );

    /* ---------- expose open/close to the shared public API ---------- */

    // The last initialized section wins as the "active" controller for
    // open/close/toggle. Multi-section cart drawers are unusual, but we
    // fall through to any registered section when called.
    section.__odditOpen = open;
    section.__odditClose = close;
    section.__odditToggle = toggle;
  }

  function destroySection(section) {
    if (!section) return;
    if (section.__odditAbortController) {
      section.__odditAbortController.abort();
      section.__odditAbortController = null;
    }
    delete section.dataset.odditCartDrawerInit;
    unregisterSection(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    // Hydrate state from server on first load
    if (sections.length) {
      refreshCart().catch(function () {
        /* noop */
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // bfcache restore (Safari especially) can replay the previous DOM
  // state — including a drawer that was left open. Force-close on every
  // pageshow so the drawer never appears to "pop out" on refresh / back.
  window.addEventListener('pageshow', function () {
    sections.forEach(function (s) {
      if (!s.classList.contains(OPEN_CLASS)) return;
      if (typeof s.__odditClose === 'function') {
        s.__odditClose();
      } else {
        s.classList.remove(OPEN_CLASS);
        s.setAttribute('aria-hidden', 'true');
        document.body.classList.remove(BODY_LOCK_CLASS);
      }
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      initSection(section);
      refreshCart().catch(function () {
        /* noop */
      });
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });

  /* ------------------------------------------------------------------ *
   * Public API
   * ------------------------------------------------------------------ */

  function callOnActiveSection(methodName) {
    // Prefer a currently-open section, else the last registered one
    var target = null;
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].classList.contains(OPEN_CLASS)) {
        target = sections[i];
        break;
      }
    }
    if (!target) target = sections[sections.length - 1];
    if (target && typeof target[methodName] === 'function') {
      target[methodName]();
    }
  }

  window.OdditCartDrawer = {
    open: function () {
      var target = sections[sections.length - 1];
      if (target && typeof target.__odditOpen === 'function')
        target.__odditOpen();
    },
    close: function () {
      for (var i = 0; i < sections.length; i++) {
        if (typeof sections[i].__odditClose === 'function')
          sections[i].__odditClose();
      }
    },
    toggle: function () {
      var target = sections[sections.length - 1];
      if (target && typeof target.__odditToggle === 'function')
        target.__odditToggle();
    },
    addToCart: addToCart,
    addMultipleToCart: addMultipleToCart,
    removeFromCart: removeFromCart,
    updateLineItemQuantity: updateLineItemQuantity,
    updateLineItemToSubscription: updateLineItemToSubscription,
    getCart: getCart,
    refreshCart: refreshCart,
    renderCart: renderCart,
    formatMoney: formatMoney
  };

  // Backwards-compatible camelCase alias (read-only reference to the same obj)
  window.odditCartDrawer = window.OdditCartDrawer;

  // Global add-to-cart delegation:
  //   * [data-add-to-cart][data-variant-id]          → the main PDP ATC. Applies
  //     the bundle-size × user-quantity multiplier.
  //   * [data-upsell-add-to-cart][data-variant-id]   → upsell / cross-sell /
  //     cart-drawer bundle cards. Adds quantity from data-quantity (defaults to
  //     1) — the section's quantity selector is intentionally ignored.
  //
  // Upsells deliberately use a separate attribute because the Kaching Bundles
  // app's inline custom snippet hijacks `button[data-add-to-cart]` clicks on
  // Kaching-configured PDPs (it stops propagation and adds whatever tier is
  // currently selected, ignoring the button's own variant). Renaming the
  // upsell attribute makes that snippet skip these buttons.
  //
  // Buttons can opt out entirely with [data-skip-global-add].
  // Registered in capture phase so it runs before the cart drawer panel's
  // stopPropagation handler (which exists to prevent overlay-click-close).
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-additional-checkout]')) return;
    if (e.target.closest('[data-skip-global-add]')) return;

    var mainAddBtn = e.target.closest('[data-add-to-cart][data-variant-id]');
    var upsellAddBtn = mainAddBtn
      ? null
      : e.target.closest('[data-upsell-add-to-cart][data-variant-id]');
    var addBtn = mainAddBtn || upsellAddBtn;
    if (!addBtn) return;

    var variantId = Number(addBtn.getAttribute('data-variant-id'));
    if (!variantId) return;

    e.preventDefault();

    var quantity;
    if (mainAddBtn) {
      // Main PDP ATC: data-quantity = bundle pack size (e.g. "2pc" → 2,
      // "4 Pack" → 4) from the variant metafield / option label. Multiply
      // by the section's quantity selector value so the cart receives
      // (pack size) × (user count).
      var bundleQty = Number(addBtn.getAttribute('data-quantity')) || 1;
      var userQty = 1;
      var qtyScope =
        addBtn.closest('.oddit-section-product-main') ||
        addBtn.closest('.shopify-section') ||
        document;
      var qtyInput =
        qtyScope.querySelector(
          '[data-block-type="quantity-selector"] input[name="quantity"]'
        ) ||
        qtyScope.querySelector('input.oddit-section-product-main__quantity-input') ||
        qtyScope.querySelector('input[name="quantity"]');
      if (qtyInput) {
        var parsedQty = parseInt(qtyInput.value, 10);
        if (parsedQty > 0) userQty = parsedQty;
      }
      quantity = bundleQty * userQty;
    } else {
      // Upsell / cross-sell / cart-drawer bundle: ignore the section's
      // quantity selector (which belongs to the main product), and add
      // exactly what the button asks for.
      quantity = Number(addBtn.getAttribute('data-quantity')) || 1;
    }
    var giftVariantId = Number(addBtn.getAttribute('data-gift-variant-id')) || 0;

    var addPromise;
    if (giftVariantId && giftVariantId !== variantId) {
      addPromise = addMultipleToCart([
        { id: variantId, quantity: quantity },
        { id: giftVariantId, quantity: 1, properties: { _gift: 'true' } }
      ]);
    } else {
      addPromise = addToCart(variantId, quantity);
    }

    addBtn.disabled = true;
    addPromise
      .then(function () {
        if (window.OdditCartDrawer && typeof window.OdditCartDrawer.open === 'function') {
          window.OdditCartDrawer.open();
        }
      })
      .catch(function (err) {
        console.error('[oddit-cart-drawer]', err);
      })
      .finally(function () {
        addBtn.disabled = false;
      });
  }, true);
})();